import dynamic from "next/dynamic";
import { GetServerSideProps } from "next";

const HocHead = dynamic(
  () => import("@/Components/HigherOrderComponent/HocHead"),
);

const Sitemap = ({ slugs }: any) => {
  const getSlugHref = (slug: string, slugKey: string) => {
    if (
      slug === slugKey ||
      ["pages", "template-pages", "ghost"].includes(slugKey)
    ) {
      return `/${slug}`;
    }
    return `/${slugKey}/${slug}`;
  };

  const seo = {
    metaTitle: "Sitemap | TRooTech",
    metaDescription:
      "Discover TRooTech's Sitemap: Effortlessly navigate Careers, Tutorials, Systems, and Resources to find opportunities, enhance skills, and access valuable insights",
  };

  return (
    <>
      {seo && <HocHead seo={seo} />}

      <div className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-center text-3xl font-bold mb-10">Sitemap</h1>

          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 gap-6">
            {Object.keys(slugs).map((slugKey) => (
              <div
                key={`${slugKey}-col`}
                className="border rounded-lg shadow-sm"
              >
                <details className="group p-4">
                  <summary className="cursor-pointer font-semibold text-lg flex justify-between items-center">
                    {slugKey}
                    <span className="transition sitemap-chevron">
                      &#9656;
                    </span>
                  </summary>

                  <div className="mt-3 pl-4 border-l">
                    <ul className="space-y-1">
                      {slugs[slugKey].map((slug: string) => (
                        <li key={`${slug}-link`}>
                          <a
                            href={getSlugHref(slug, slugKey)}
                            className="text-blue-600 hover:underline capitalize"
                          >
                            {slug?.replaceAll("-", " ")}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  return {
    redirect: {
      destination: "/sitemap.xml",
      permanent: true, // use false if this is temporary
    },
  };
};
export default Sitemap;
